var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.cssClass.parent,on:{"click":_vm.click}},[_c('object',{class:_vm.cssClass.icon,attrs:{"type":"image/svg+xml","width":_vm.iconSize,"height":_vm.iconSize}})])
}
var staticRenderFns = []

export { render, staticRenderFns }